"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/date-picker/style/css");

var _datePicker = _interopRequireDefault(require("antd/es/date-picker"));

var _react = _interopRequireWildcard(require("react"));

var _cloneDeep = _interopRequireDefault(require("lodash/cloneDeep"));

var _moment = _interopRequireDefault(require("moment"));

var _select = _interopRequireDefault(require("antd/lib/select"));

var _button = _interopRequireDefault(require("antd/lib/button"));

var _card = _interopRequireDefault(require("antd/lib/card"));

var _radio = _interopRequireDefault(require("antd/lib/radio"));

var _form = _interopRequireDefault(require("antd/lib/form"));

var _input = _interopRequireDefault(require("antd/lib/input"));

var _reselect = require("reselect");

var selectors = _interopRequireWildcard(require("../../../../redux/selectors"));

var _reactRedux = require("react-redux");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

class ParticipantEditCard extends _react.Component {
  constructor() {
    super(...arguments);
    this.state = {
      participant: (0, _cloneDeep.default)(this.props.initialParticipant),
      validateStatus: {}
    };
    this.form = /*#__PURE__*/_react.default.createRef();

    this.handleSubmit = () => {
      if (this.form.current) {
        this.form.current.validateFields().then(() => {
          const isValid = this.validatePassword();

          if (isValid) {
            this.props.saveClickHandler(this.state.participant);
          }
        });
      }
    };

    this.validatePassword = () => {
      let isValid = true;

      if (!!this.state.participant.password) {
        if (!this.state.participant.passwordConfirm || this.state.participant.password !== this.state.participant.passwordConfirm) {
          this.setState({
            validateStatus: { ...this.state.validateStatus,
              passwordConfirm: 'error'
            }
          });
          isValid = false;
        }
      }

      if (isValid) {
        this.setState({
          validateStatus: { ...this.state.validateStatus,
            passwordConfirm: undefined
          }
        });
      }

      return isValid;
    };
  }

  render() {
    const {
      studyArm,
      cancelClickHandler,
      accessCodeEnrollmentEnabled,
      referralCodeEnrollmentEnabled
    } = this.props;
    const {
      participant
    } = this.state;
    const dateFormat = 'MM/DD/YYYY';
    const {
      TextArea
    } = _input.default;
    const {
      Option
    } = _select.default;
    return /*#__PURE__*/_react.default.createElement(_card.default, {
      key: "edit"
    }, /*#__PURE__*/_react.default.createElement(_form.default, {
      ref: this.form,
      key: participant.id,
      onFinish: this.handleSubmit
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "profile"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "profile-container"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "demo"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "demo-section"
    }, /*#__PURE__*/_react.default.createElement(_form.default.Item, {
      name: "firstName",
      label: "First Name",
      rules: [{
        required: true,
        message: 'First name is required!'
      }],
      initialValue: participant.firstName
    }, /*#__PURE__*/_react.default.createElement(_input.default, {
      onChange: v => {
        participant.firstName = v.target.value;
      }
    })), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
      name: "lastName",
      label: "Last Name"
    }, /*#__PURE__*/_react.default.createElement(_input.default, {
      defaultValue: participant.lastName,
      onChange: v => {
        participant.lastName = v.target.value;
      }
    })), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
      name: "username",
      label: "Username"
    }, /*#__PURE__*/_react.default.createElement("label", null, participant.username)), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
      name: "password",
      label: "Password",
      rules: [{
        min: 8,
        message: 'Minimum 8 characters'
      }]
    }, /*#__PURE__*/_react.default.createElement(_input.default, {
      autoComplete: "off",
      type: "password",
      onChange: v => {
        participant.password = v.target.value;
        this.validatePassword();
      }
    })), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
      name: "passwordConfirm",
      label: "Confirm Password",
      hasFeedback: true,
      validateStatus: this.state.validateStatus['passwordConfirm'],
      help: !!this.state.validateStatus['passwordConfirm'] ? 'Must match password' : undefined
    }, /*#__PURE__*/_react.default.createElement(_input.default, {
      type: "password",
      autoComplete: "off",
      onChange: v => {
        participant.passwordConfirm = v.target.value;
        this.validatePassword();
      }
    })), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
      name: "email",
      label: "Email",
      rules: [{
        required: true,
        message: 'Email is required!'
      }],
      initialValue: participant.email
    }, /*#__PURE__*/_react.default.createElement(_input.default, {
      onChange: v => {
        participant.email = v.target.value;
      }
    })), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
      name: "mobile",
      label: "Mobile"
    }, /*#__PURE__*/_react.default.createElement(_input.default, {
      defaultValue: participant.mobile,
      onChange: v => {
        participant.mobile = v.target.value;
      }
    })), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
      name: "address1",
      label: "Address"
    }, /*#__PURE__*/_react.default.createElement(_input.default, {
      defaultValue: participant.address1,
      onChange: v => {
        participant.address1 = v.target.value;
      }
    })), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
      name: "address2",
      label: "Line 2"
    }, /*#__PURE__*/_react.default.createElement(_input.default, {
      defaultValue: participant.address2,
      onChange: v => {
        participant.address2 = v.target.value;
      }
    })), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
      name: "city",
      label: "City"
    }, /*#__PURE__*/_react.default.createElement(_input.default, {
      defaultValue: participant.city,
      onChange: v => {
        participant.city = v.target.value;
      }
    })), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
      name: "state",
      label: "State"
    }, /*#__PURE__*/_react.default.createElement(_input.default, {
      defaultValue: participant.state,
      onChange: v => {
        participant.state = v.target.value;
      }
    })), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
      name: "postalCode",
      label: "Postal Code"
    }, /*#__PURE__*/_react.default.createElement(_input.default, {
      defaultValue: participant.postalCode,
      onChange: v => {
        participant.postalCode = v.target.value;
      }
    })), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
      name: "dateOfBirth",
      label: "Date of Birth"
    }, /*#__PURE__*/_react.default.createElement(_datePicker.default, {
      defaultValue: (0, _moment.default)(participant.dateOfBirth),
      format: dateFormat,
      onChange: (date, dateString) => {
        participant.dateOfBirth = date ? date.toDate() : undefined;
      }
    })), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
      name: "age",
      label: "Age"
    }, /*#__PURE__*/_react.default.createElement("label", null, (0, _moment.default)().diff(participant.dateOfBirth, 'years'))), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
      name: "genderAtBirth",
      label: "Sex at Birth"
    }, /*#__PURE__*/_react.default.createElement(_radio.default.Group, {
      defaultValue: participant.genderAtBirth,
      onChange: v => {
        participant.genderAtBirth = v.target.value;
      }
    }, /*#__PURE__*/_react.default.createElement(_radio.default, {
      value: "F"
    }, "FEMALE"), /*#__PURE__*/_react.default.createElement(_radio.default, {
      value: "M"
    }, "MALE"))), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
      name: "genderIdentity",
      label: "Gender Identity"
    }, /*#__PURE__*/_react.default.createElement(_input.default, {
      defaultValue: participant.genderIdentity,
      onChange: v => {
        participant.genderIdentity = v.target.value;
      }
    })), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
      name: "ethnicity",
      label: "Ethnicity"
    }, /*#__PURE__*/_react.default.createElement(_input.default, {
      defaultValue: participant.ethnicity,
      onChange: v => {
        participant.ethnicity = v.target.value;
      }
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: "demo-section"
    }, /*#__PURE__*/_react.default.createElement(_form.default.Item, {
      name: "createDate",
      label: "Created Date"
    }, /*#__PURE__*/_react.default.createElement("label", null, (0, _moment.default)(participant.createDate).format('MM/DD/YYYY'))), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
      name: "studyArm",
      label: "Study Arm"
    }, /*#__PURE__*/_react.default.createElement("label", null, studyArm.name)), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
      name: "status",
      label: "Status"
    }, /*#__PURE__*/_react.default.createElement(_select.default, {
      style: {
        width: 200
      },
      defaultValue: participant.status,
      onChange: value => {
        participant.status = value;
      }
    }, /*#__PURE__*/_react.default.createElement(Option, {
      value: "APPLIED"
    }, "APPLIED"), /*#__PURE__*/_react.default.createElement(Option, {
      value: "DISQUALIFIED"
    }, "DISQUALIFIED"), /*#__PURE__*/_react.default.createElement(Option, {
      value: "ACCEPTED"
    }, "ACCEPTED"), /*#__PURE__*/_react.default.createElement(Option, {
      value: "ACTIVE"
    }, "ACTIVE"), /*#__PURE__*/_react.default.createElement(Option, {
      value: "DROPPED"
    }, "DROPPED"), /*#__PURE__*/_react.default.createElement(Option, {
      value: "DISMISSED"
    }, "DISMISSED"), /*#__PURE__*/_react.default.createElement(Option, {
      value: "FINISHED"
    }, "FINISHED"))), accessCodeEnrollmentEnabled && /*#__PURE__*/_react.default.createElement(_form.default.Item, {
      label: "Access Code"
    }, /*#__PURE__*/_react.default.createElement(_input.default, {
      defaultValue: participant.accessCode,
      onChange: v => {
        participant.accessCode = v.target.value;
      }
    })), referralCodeEnrollmentEnabled && /*#__PURE__*/_react.default.createElement(_form.default.Item, {
      label: "Referral Code"
    }, /*#__PURE__*/_react.default.createElement(_input.default, {
      defaultValue: participant.referralCode,
      onChange: v => {
        participant.referralCode = v.target.value;
      }
    })), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
      name: "pin",
      label: "Pin"
    }, /*#__PURE__*/_react.default.createElement(_input.default, {
      defaultValue: participant.pin,
      onChange: v => {
        participant.pin = v.target.value;
      }
    })), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
      name: "externalId",
      label: "External ID"
    }, /*#__PURE__*/_react.default.createElement(_input.default, {
      defaultValue: participant.externalId,
      onChange: v => {
        participant.externalId = v.target.value;
      },
      maxLength: 100
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: "demo-section"
    }, /*#__PURE__*/_react.default.createElement(_form.default.Item, {
      name: "appliedDate",
      label: "Applied Date"
    }, /*#__PURE__*/_react.default.createElement(_datePicker.default, {
      defaultValue: participant.appliedDate ? (0, _moment.default)(participant.appliedDate) : undefined,
      format: dateFormat,
      onChange: (date, dateString) => {
        participant.appliedDate = date ? date.toDate() : undefined;
      }
    })), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
      name: "acceptedDate",
      label: "Accepted Date"
    }, /*#__PURE__*/_react.default.createElement(_datePicker.default, {
      defaultValue: participant.acceptedDate ? (0, _moment.default)(participant.acceptedDate) : undefined,
      format: dateFormat,
      onChange: (date, dateString) => {
        participant.acceptedDate = date ? date.toDate() : undefined;
      }
    })), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
      name: "startDate",
      label: "Start Date"
    }, /*#__PURE__*/_react.default.createElement(_datePicker.default, {
      defaultValue: participant.startDate ? (0, _moment.default)(participant.startDate) : undefined,
      format: dateFormat,
      onChange: (date, dateString) => {
        participant.startDate = date ? date.toDate() : undefined;
      }
    })), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
      name: "endDate",
      label: "End Date"
    }, /*#__PURE__*/_react.default.createElement(_datePicker.default, {
      defaultValue: participant.endDate ? (0, _moment.default)(participant.endDate) : undefined,
      format: dateFormat,
      onChange: (date, dateString) => {
        participant.endDate = date ? date.toDate() : undefined;
      }
    })), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
      name: "mobileEnrollmentDate",
      label: "Mobile Enroll Date"
    }, /*#__PURE__*/_react.default.createElement(_datePicker.default, {
      defaultValue: participant.mobileEnrollmentDate ? (0, _moment.default)(participant.mobileEnrollmentDate) : undefined,
      format: dateFormat,
      onChange: (date, dateString) => {
        participant.mobileEnrollmentDate = date ? date.toDate() : undefined;
      }
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: "demo-section"
    }, /*#__PURE__*/_react.default.createElement(_form.default.Item, {
      name: "aboutMe",
      label: "About Me",
      style: {
        alignItems: 'flex-start'
      }
    }, /*#__PURE__*/_react.default.createElement(TextArea, {
      rows: 3,
      defaultValue: participant.aboutMe,
      onChange: v => {
        participant.aboutMe = v.target.value;
      },
      style: {
        width: '250px'
      }
    })))), /*#__PURE__*/_react.default.createElement("div", {
      className: "actions"
    }, /*#__PURE__*/_react.default.createElement(_button.default, {
      htmlType: "submit"
    }, "Save"), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: cancelClickHandler
    }, "Cancel"))))));
  }

}

const mapStateToProps = (0, _reselect.createStructuredSelector)({
  accessCodeEnrollmentEnabled: selectors.getAccessCodeEnrollmentEnabled,
  referralCodeEnrollmentEnabled: selectors.getReferralsFeatureEnabled
});

var _default = (0, _reactRedux.connect)(mapStateToProps, null)(ParticipantEditCard);

exports.default = _default;